module.exports = function () {

    function wowTrimFilter(trimString, shouldTrim, trimLength = 3) {
        if (shouldTrim) {
            if (trimString && typeof trimString === 'string' && trimString.length >= trimLength) {
                return trimString.substring(0, trimLength);
            }
        }

        return trimString;
    }

    return wowTrimFilter;
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-trim.js